/**
 * Domain Adapter — Infrastructure (IFC 4.3 Infrastructure)
 *
 * Phase-2 deliverable. Covers bridges, tunnels, roads, and rail alignments
 * per IFC 4.3 infrastructure types (IfcBridge, IfcRailway, IfcRoad).
 * Not-yet-implemented; returns an explicit typed error.
 */

import type { SceneItem } from "@/sdk-stub/gtwin-sdk/types";
import type { DomainAdapter, DomainAdapterContext, AdapterResult } from "../DomainAdapter";

export const IfcInfraAdapter: DomainAdapter = {
  domain: "infrastructure",
  version: "1.0.0",
  standard: "IFC:4.3",

  /**
   * Detects IFC infrastructure assets.
   * Matches `layerKind === "ifc-infra"` or explicit domain extension.
   */
  detect(item: SceneItem): boolean {
    type Extended = SceneItem & { extensions?: { geosoft?: { domain?: string } } };
    const ext = (item as Extended).extensions?.geosoft;
    if (ext?.domain === "infrastructure") return true;
    return item.layerKind === "ifc-infra";
  },

  async buildManifest(
    _item: SceneItem,
    _asset: { layerId: string; assetNodeId: string; gtwinId: string },
    _context: DomainAdapterContext,
  ): Promise<AdapterResult> {
    return {
      ok: false,
      error: {
        kind: "not-implemented",
        domain: "infrastructure",
        message:
          "Phase 2 deliverable; fall back to synthetic Tier-1 view.",
      },
    };
  },
};
